var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviderMultiversx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#23F7DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 10.5007L15.8125 7.7741L14.9451 6.125L10.221 8.01515C10.0993 8.06388 9.96449 8.06388 9.84286 8.01515L5.11735 6.125L4.25 7.7741L9.40918 10.5007L4.25 13.2259L5.11735 14.875L9.84153 12.9849C9.96316 12.9361 10.098 12.9361 10.2196 12.9849L14.9439 14.875L15.8112 13.2259L10.652 10.4993L10.6533 10.5007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderMultiversx);
export default __webpack_public_path__ + "static/media/provider-multiversx.79f37259d82fddc0230900b3efa88d8e.svg";
export { ForwardRef as ReactComponent };